import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Tabs } from "@mwi/ui";

const CustomisationsLayout = (): JSX.Element => {
  const location = useLocation();

  if (location.pathname === "/admin/customisations") {
    return <Navigate to="/admin/customisations/logo" replace />;
  }

  return (
    <>
      <div className="mb-12">
        <h1 className="text-[28px] leading-[34px] tablet:text-5xl tablet:leading-[58px]">
          Customisation
        </h1>
      </div>

      <Tabs className="gap-x-10">
        <Tabs.Item
          className="h-[35px]"
          title="Logo"
          isActive={location.pathname === "/admin/customisations/logo"}
          to="/admin/customisations/logo"
        />
        <Tabs.Item
          className="h-[35px]"
          title="Colours"
          isActive={location.pathname === "/admin/customisations/colours"}
          to="/admin/customisations/colours"
        />
        <Tabs.Item
          className="h-[35px]"
          title="Login page"
          isActive={location.pathname === "/admin/customisations/login-page"}
          to="/admin/customisations/login-page"
        />
        <Tabs.Item
          className="h-[35px]"
          title="Vocabulary"
          isActive={location.pathname === "/admin/customisations/vocabulary"}
          to="/admin/customisations/vocabulary"
        />
        <Tabs.Item
          className="h-[35px]"
          title="Links"
          isActive={location.pathname === "/admin/customisations/links"}
          to="/admin/customisations/links"
        />
      </Tabs>

      <div className="flex flex-col flex-grow py-12">
        <Outlet />
      </div>
    </>
  );
};

export default CustomisationsLayout;
